import React, { useContext, useCallback } from 'react';
import Spreadsheet from 'react-spreadsheet';

import { useFormattedTableData, updateChillerLogFieldIfChanged } from '../../../utils/highlightedDataUtil';
import { ChillerLogsContext } from '../contexts/ChillerLogsContext';
import { ChillerCircuit } from '../../model';

interface CondenserDetailsSubsectionProps {
  chillerCircuit: ChillerCircuit;
  col?: number;
}

const CondenserDetailsSubsection: React.FunctionComponent<CondenserDetailsSubsectionProps> = (props) => {
  let { chillerCircuit, col } = props;

  const { chillerLog, setChillerLog, saveCurrentLogToLocalStorage, currentLogApproved } =
    useContext(ChillerLogsContext);

  let classes = 'chiller-spreadsheet';
  if (col === 3) {
    classes += ' third-column';
  }

  let readIndex = chillerCircuit?.index + 1;
  let tableData = useFormattedTableData(chillerCircuit?.condenser_details, col, currentLogApproved);
  let columnLabels = ['', '', '', `Circuit ${readIndex}`];

  const handleSpreadsheetChange = useCallback(
    (updatedData) => {
      updateChillerLogFieldIfChanged({
        chillerLog,
        setChillerLog,
        updatedData,
        currentFieldValue: chillerCircuit.condenser_details,
        getField: (log) => log.circuits[chillerCircuit.index].condenser_details,
        setField: (log, value) => {
          log.circuits[chillerCircuit.index].condenser_details = value;
        },
      });
    },
    [setChillerLog, chillerLog, chillerCircuit],
  );

  return (
    <Spreadsheet
      data={tableData}
      hideRowIndicators
      columnLabels={[columnLabels[col]]}
      onChange={handleSpreadsheetChange}
      className={classes}
      onBlur={saveCurrentLogToLocalStorage}
    />
  );
};

export default CondenserDetailsSubsection;
